// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"8bbd83ef","703":"391cce71","787":"e7c56073"}[chunkId] + ".chunk.js";
};